// extracted by mini-css-extract-plugin
export var addButton = "_ds-4";
export var contentBlockImage = "_ds-i";
export var contentBlockWidgetPreview = "_ds-g";
export var fulfillmentCutoffWidgetPreview = "_ds-9";
export var imageBackdrop = "_ds-6";
export var imageIcon = "_ds-8";
export var lowProfileImageContainer = "_ds-b";
export var lowProfileImageIcon = "_ds-f";
export var lowProfileImageIconContainer = "_ds-e";
export var lowProfileImagePlaceholder = "_ds-d";
export var lowProfileProductImage = "_ds-c";
export var lowProfileProductUpsellWidgetPreview = "_ds-a";
export var productCard = "_ds-5";
export var productImage = "_ds-7";
export var productReviewsWidgetPreview = "_ds-h";
export var progressBar = "_ds-1";
export var progressBarFill = "_ds-2";
export var progressBarTrack = "_ds-3";
export var shippingOptionWidgetPreview = "_ds-j";
export var shippingUpsellProgressBar = "_ds-k";
export var thresholdUpsellWidgetPreview = "_ds-0";